export default class HeaderScroll {
  constructor() {
    this.getDomElements()

    if (!this.dom.header) return
    
    this.init()
  }


  init() {
    this.handleScroll()
  }

  handleScroll() {
    if (!this.dom.statusBar) {
      this.dom.header.classList.add('is-scroll')
    } else {
      const height = this.dom.statusBar.scrollHeight

      document.addEventListener("scroll", () => {
        if (document.scrollingElement.scrollTop > height) { 
          this.dom.header.classList.add('is-scroll')
          this.dom.header.style.top = -height + 'px'
        } else { 
          this.dom.header.classList.remove('is-scroll')
          this.dom.header.style.top = 0
        }
      })  
    }
  }

  getDomElements() {
    this.dom = {
      'header' : document.querySelector('.js-header'),
      'statusBar' : document.querySelector('.js-status-bar'),
    }
  }
}